"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersaoGrade = void 0;
var VersaoGrade = /** @class */ (function () {
    function VersaoGrade() {
        this._id = { m: '', v: '', g: '' };
        this.MATERIAL = '';
        this.VERSAO = '';
        this.GRUPO_UME = '';
        this.CHAVE_COMP = { m: '', g: '' };
    }
    return VersaoGrade;
}());
exports.VersaoGrade = VersaoGrade;
//# sourceMappingURL=VersaoGrade.js.map